// removed by extract-text-webpack-plugin
module.exports = {"component":"_33oMxdEw9U5KRhmRv8j9Oo","from":"_1o8Y9Ysx3oTAsmMY-th49C","info":"_3yU6p8_T5ECZAsfiJMkUHO","message":"_2kbwMk2KBQgPONAns_oGtJ"};